import { DATE_FORMAT, TIME_FORMAT } from "../constants";
import moment from "../moment/moment";
import { padNumber } from "./utils";

/**
 * Return the next time when the minutes are multiple of slice. If no dateTime is given, the current time will be used. 
 * @param {moment.Moment} dateTime 
 * @param {number} slice 
 * @returns {moment.Moment}
 */
export const getNextTime = (dateTime = moment(), slice = 5) => {
    const remainder = dateTime.minute() % slice === 0 ? 0 : slice - (dateTime.minute() % slice);
    dateTime.add(remainder, "minutes");
    return dateTime;
};

/**
 * Return the previous or the next time when the minutes are multiple of slice.
 * @param {moment.Moment} dateTime 
 * @param {number} slice 
 * @returns {moment.Moment}
 */
export const getRoundTime = (dateTime = moment(), slice = 5) => {
    const rest = dateTime.minute() % slice;
    dateTime.add(rest >= slice / 2 ? slice - rest : - rest, "minutes");
    return dateTime;
}

export const setToCurrentTime = (dateTime) => {
    dateTime = moment(dateTime);
    return dateTime.hour(moment().hour()).minute(moment().minute());
};

/**
 * 
 * @param {string} time 
 * @param {string} format - format of input time (default: `HH:mm:ss`)
 * @returns {moment.Moment}
 */
export const timeToMoment = (time, format = TIME_FORMAT) => moment(time, format);

/**
 * 
 * @param {moment.Moment} momentObj 
 * @param {string} format - format of ouput time (default: `HH:mm:ss`)
 * @returns {string}
 */
export const momentToTime = (momentObj, format = TIME_FORMAT) => momentObj.format(format);

export const getHoursBetween = (momentA = moment(), momentB = moment(), slice = 5) => {

    const result = [];

    momentA = momentA.clone();
    momentB = momentB.clone();

    while (momentA.isBefore(momentB)) {
        result.push(momentA.clone());
        momentA.add(slice, 'minutes');
    }

    result.push(momentB);

    return result;
}

/**
 * Check if a given date is in the past.
 * @param {moment.Moment} date 
 * @param {moment.Moment} startDate 
 * @returns 
 */
export const isPastDate = (date, startDate = moment()) => {
    const today = startDate.startOf('day');
    date = moment(date);
    return today.isAfter(date);
}

/**
 * Check if a year is a leap year or not.
 * @param {number} year 
 * @returns {boolean}
 */
export const isLeapYear = (year = 0) => (year > 1582 && ((year % 4 === 0 && year % 100 !== 0) || (year % 400 === 0)));


/**
 * 
 * @param {moment.Moment} start 
 * @param {moment.Moment} end 
 */
export const getWeekdaysBetween = (start = moment(), end = moment()) => {

    if (start.isAfter(end)) {
        [start, end] = [end, start];
    }
    const daysDiff = end.diff(start, 'days');
    const weekdays = new Set();
    const currentDate = start.isoWeekday();

    for (let i = 0; i <= daysDiff; i++) {
        weekdays.add(((currentDate - 1 + i) % 7) + 1);
        if (weekdays.size == 7)
            break;
    }

    return weekdays;
}

/**
 * 
 * @param {string} durationString 
 */
export const buildDurationObject = durationString => {
    const duration = moment.duration(durationString);
    if (!duration.isValid()) {
        return {};
    }
    return {
        days: duration.days(),
        hours: duration.hours(),
        minutes: duration.minutes(),
        seconds: duration.seconds(),
        duration,
    };
}

export const buildDurationString = ({ days = 0, hours = 0, minutes = 0, seconds = 0 }) => {
    let [_hours, _minutes, _seconds] = [hours, minutes, seconds].map(padNumber);
    const _durationString = `${days} ${_hours}:${_minutes}:${_seconds}`;
    const duration = moment.duration(_durationString);
    [days, _hours, _minutes, _seconds] = [duration.days(), duration.hours(), duration.minutes(), duration.seconds()].map(padNumber);
    return `${days} ${_hours}:${_minutes}:${_seconds}`;
}

export function getFormattedDatetime(datetime, format = "llll") {
    if (datetime === null) {
        return "Pas de limite de validité"
    }
    return moment(datetime).format(format);
}

export const getFormattedDate = (rawDate) => moment(rawDate).format('DD/M/YYYY');

/**
 * Combines a date and a time as a Moment object.
 * @param {string} date 
 * @param {string} time 
 * @returns 
 */
export function combineDateAndTime(date, time) {
    return moment(
        `${date} ${time}`,
        `${DATE_FORMAT} ${TIME_FORMAT}`,
    )
}


// WEBPACK FOOTER //
// ./src/helpers/time.js